import { toast } from "@/hooks/use-toast";

export const scrollToElement = (elementId: string | undefined | null) => {
  if (!elementId) return;
  const element = document.getElementById(`section-${elementId}`);
  if (!element) return;
  element.scrollIntoView({ behavior: "smooth", block: "start" });
};

export const handleCopyToClipboard = async (text: string) => {
  if (!text) return;
  try {
    await navigator.clipboard.writeText(text);
    toast({
      title: "Copied to clipboard",
      description: `${text} has been copied`,
      duration: 2000,
    });
  } catch (err) {
    toast({
      title: "Failed to copy",
      description: "Please try again",
      variant: "destructive",
      duration: 2000,
    });
  }
};
